<template>
  <fragment>
    <Button v-b-modal.customized-modal-criteria class="right-side">Create Criteria</Button>
    <b-modal
      id="customized-modal-criteria"
      title="Create Criteria"
      no-close-on-backdrop
      centered
      @ok="
        evt => {
          const temp = $emit('onSubmit', this.form);
          // Hide the modal manually
          this.$nextTick(() => {
            this.$bvModal.hide('modal-prevent-closing');
          });
        }
      "
    >
      <b-form-group label="Title" label-for="id-criteria">
        <b-form-input
          id="id-criteria"
          placeholder="Short description of a criteria"
          required
          type="text"
          v-model="form.title"
        />
      </b-form-group>

      <b-form-group label="Explanation" label-for="id-explanation">
        <b-form-textarea id="id-explanation" rows="3" v-model="form.explanation" />
      </b-form-group>

      <b-form-group label="Type" label-for="id-type">
        <b-form-select :options="options" id="id-type" v-model="form.type" />
      </b-form-group>
    </b-modal>
  </fragment>
</template>

<script>
import Button from '@/components/Button';

export default {
  name: 'CreateCriteriaForm',
  components: { Button },
  data() {
    return {
      form: {
        title: null,
        explanation: null,
        type: 'CROSS',
      },
      options: [
        { value: 'CROSS', text: 'Select type (optional)' },
        { value: 'CROSS', text: 'cross review' },
        { value: 'LEAD', text: 'lead review' },
        { value: 'SELF', text: 'self review' },
      ],
    };
  },
};
</script>
